import type { FinpspTransactionReport } from '../@types/api';
import { FINPSP_STATE, FINPSP_STATE_LABELS } from '../constants/finpsp';

export const getFinpspStatusLabel = (facts: FinpspTransactionReport) => {
  if (facts.state === FINPSP_STATE.PENDING && facts.providerStatus === 'waiting')
    return 'Waiting for provider verification';
  if (facts.state === FINPSP_STATE.PENDING && facts.providerStatus === 'processing') return 'Provider processing';
  return FINPSP_STATE_LABELS[facts.state] ?? 'Unknown FINPSP state';
};
